import { render } from "./HeroiconsOutlinePhotograph.vue?vue&type=template&id=d4bf5ec2"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePhotograph.vue"]])

export default __exports__